'use client'

import Link from 'next/link'
import { Route } from 'next'
import { RenderLink } from '@/devlink/DevLinkProvider'

export const LinkRenderer: RenderLink = ({
  href,
  className,
  children,
  ...props
}) => (
  <Link href={href as Route} className={className} {...props}>
    {children}
  </Link>
)
